import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ILurikProcess } from '../../models';

interface ILurikProcessState {
  lurikProcess?: ILurikProcess
}

const initialState: ILurikProcessState = {

};

const lurikProcessSlice = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setLurikProcessState: (state, action: PayloadAction<ILurikProcess>) => {
      state.lurikProcess = action.payload;
    }
  },
});

export const { setLurikProcessState } = lurikProcessSlice.actions;
export const lurikProcessReducer = lurikProcessSlice.reducer;